export const createStockToRepairStatusMap = (normalizeStatusName) => ({
  [normalizeStatusName('In Stock')]: [normalizeStatusName('Serviceable')],
  [normalizeStatusName('Fitted')]: [normalizeStatusName('In Service')],
  [normalizeStatusName('In Quarantine')]: [normalizeStatusName('Unserviceable')],
  [normalizeStatusName('Awaiting Pickup')]: [
    normalizeStatusName('Requires Repair')
  ],
  [normalizeStatusName('At Supplier')]: [normalizeStatusName('Under Repair')],
  [normalizeStatusName('Scrapped')]: [normalizeStatusName('Left The System')],
  [normalizeStatusName('Sold')]: [normalizeStatusName('Left The System')],
  [normalizeStatusName('On Order')]: [normalizeStatusName('Serviceable')],
  [normalizeStatusName('In Transit')]: [
    normalizeStatusName('Requires Repair'),
    normalizeStatusName('Serviceable'),
    normalizeStatusName('Unserviceable'),
  ],
});
